<template>
  <v-card flat tile max-width="500px" class="mx-auto mb-2">
    <v-list-item class="px-0">
      <v-list-item-avatar class="mr-2" size="40" @click="openProfile()">
        <v-img
          v-if="userData.picture"
          :src="userData.picture"
          width="30px"
        ></v-img>
        <user-logo v-else :size="40" />
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title
          v-if="userData.name"
          class="text-sm md:text-lg d-flex align-center"
        >
          {{ userData.name }}
        </v-list-item-title>
        <v-list-item-title v-else> username </v-list-item-title>
        <v-list-item-subtitle class="text-xs md:text-sm">
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-img
          src="https://firebasestorage.googleapis.com/v0/b/around-a8790.appspot.com/o/fly_platforms%2Ficons%2Fpinterest.png?alt=media&token=255301e8-3e8d-4df9-9120-ec3d986c3490"
          width="30px"
        ></v-img>
      </v-list-item-action>
    </v-list-item>
    <v-card-text class="pa-0" v-if="hasPreview">
      <div v-html="pinterest_text ? pinterest_text : content" class="mb-3 text-lg" />
    </v-card-text>
    <v-card :href="url" target="_blank" v-if="hasPreview">
      <v-img :src="detail?.image" />
      <v-card-title>{{ detail?.title }}</v-card-title>
      <v-card-text>{{ detail?.description }}</v-card-text>
    </v-card>
    <v-card-text v-else class="pa-0">
      <div v-html="pinterest_text ? pinterest_text : content" class="mb-3 text-lg" />
      <div v-html="hashtags" />
      <v-carousel
        hide-delimiters
        v-model="carousel"
        v-if="carousels.length"
        :show-arrows="carousels.length > 1"
        :height="isMobile ? '400px' : '500px'"
      >
        <v-carousel-item v-for="(item, i) in carousels" :key="i">
          <div class="h-full d-flex align-center black">
            <v-img :src="item.src" v-if="item.type == 'image'" />
            <video-auto-play
              v-if="item.type == 'video'"
              :autoplay="false"
              :videoSrc="item.src"
            />
          </div>
        </v-carousel-item>
      </v-carousel>
      <div class="flex justify-between my-3 align-center">
        <!-- Add a spacer between "00 notes" and v-img elements -->

        <div class="d-flex align-center">
          <v-img
            max-width="25px"
            class="mx-3 mt-1"
            src="https://img.icons8.com/fluency-systems-filled/48/ellipsis.png"
          ></v-img>
          <v-img
            max-width="23px"
            style=""
            class="mx-3 mt-1 ml-2"
            src="https://img.icons8.com/external-anggara-basic-outline-anggara-putra/24/external-share-user-interface-basic-anggara-basic-outline-anggara-putra.png"
          ></v-img>
          <v-img
            max-width="23px"
            style=""
            class="mx-3 mt-1 mr-1"
            src="https://img.icons8.com/puffy-filled/32/experimental-link-puffy-filled.png"
          ></v-img>
        </div>
        <v-spacer></v-spacer>

        <div class="px-4 py-2 mr-2 bg-red-500 rounded-xl">
          <span class="font-bold text-white">Save</span>
        </div>
      </div>
    </v-card-text>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
import UserLogo from "@/components/UserLogo.vue";
import VideoAutoPlay from "@/components/public/VideoAutoPlay.vue";

export default {
  components: { UserLogo, VideoAutoPlay },
  props: {
    post: {
      type: Object,
      default: () => ({}),
    },
    userData: {
      type: Array,
      default: () => [],
    },
    detail: Object,
    hasPreview: Boolean,
    url: String,
    configuration: {
      type: Object,
      default: () => ({}),
    },
    pinterest_text: String,
  },
  data() {
    return {
      carousel: 0,
      coverimage: "",
    };
  },
  watch: {
    "configuration.cover_image_url": {
      handler(val) {
        const vm = this;
        if (val) {
          if (typeof val === "object") {
            if (val instanceof File) {
              var reader = new FileReader();
              reader.onload = function (e) {
                vm.coverimage = e.target.result;
              };
              reader.readAsDataURL(val);
            }
          } else {
            vm.coverimage = val;
          }
        }
      },
    },
  },
  computed: {
    logoName() {
      let name = this.currentUser.display_name || "";
      return name.charAt(0).toUpperCase();
    },
    hashtags() {
      let hashtags = this.post.hashtags || [];
      return hashtags
        .map((i) => {
          if (!i.startsWith("#")) return `#${i}`;
          return i;
        })
        .toString()
        .split(",")
        .join(" ");
    },
    content() {
      let content = this.post.text || "";
      // content = content.toString().replace(/(?:\r\n|\r|\n)/g, " <br>");
      content = content.toString().replace(/(?:\r\n|\r|\n)+/g, "<br>");
      content = content.replace(
        /(https?:\/\/[^\s]+)/g,
        '<a href="$1" target="_blank" class="primary--text text-decoration-underline">$1</a>'
      );
      return content;
    },
    carousels() {
      let list = [];
      if (this.post.videos) {
        // console.log(this.post.videos);
        if (this.coverimage) {
          list.push({
            src: this.coverimage,
            type: "image",
          });
        } else {
          this.post.videos.forEach((item) => {
            list.push({
              src: item.url || item,
              type: "video",
            });
          });
        }
      }
      if (this.post.images) {
        if (this.post.images.length > 10) {
          let images = this.post.images.slice(0, 10);
          images.forEach((item) => {
            list.push({
              src: item.thumbnail || item.url || item,
              type: "image",
            });
          });
        } else {
          this.post.images.forEach((item) => {
            list.push({
              src: item.thumbnail || item.url || item,
              type: "image",
            });
          });
        }
      }
      return list;
    },
  },
};
</script>

<style></style>
